import { Redirect } from "@shopify/app-bridge/actions"

import { CROSS_SELL_POINT_ENUM } from "@/enums/CrossSellPoint"
import AppBridge, { isShopifyEmbedded } from "@/utils/app-bridge"

import { isProduction } from "./env-helper"

/**
 * 以新建标签页的方式打开指定链接
 * @param url
 */
function openCustomURL(url: string, newContext = true) {
  if (!isShopifyEmbedded()) {
    window.open(url)
    return
  }

  AppBridge.redirect().dispatch(Redirect.Action.REMOTE, {
    newContext,
    url: url,
  })
}

export { openCustomURL }

// 根据时间戳轮换WhatsApp链接的函数
const getRotatingWhatsAppLink = () => {
  const links = [
    // "https://shorturl.at/6dEqq", // wq (A)
    "https://shorturl.at/c0mA6", // kelly (B)
    "https://shorturl.at/HSRQr", // max (C)
  ]
  // 每12小时轮换一次 (12 * 60 * 60 * 1000 = 43200000毫秒)
  const rotationPeriod = 4 * 60 * 60 * 1000
  const currentTime = Date.now()
  const rotationIndex = Math.floor(currentTime / rotationPeriod) % links.length

  return links[rotationIndex]
}

/**
 * Contact 类型常量
 */
enum CONTACT_TYPES {
  WHATS_APP = "WhatsApp",
  SLACK = "Slack",
  WE_COM = "WeCom",
  DEMO = "Demo",
}

export function openMiddlewarePage(
  type: CROSS_SELL_POINT_ENUM,
  contactId?: CONTACT_TYPES,
) {
  if (contactId) {
    const urlMap = {
      [CONTACT_TYPES.DEMO]:
        "https://calendly.com/demo-parcelpanel/parcelpanel/",
      [CONTACT_TYPES.SLACK]:
        "https://join.slack.com/t/parcelwill-community/shared_invite/zt-2zol5x0o6-eIat3ZbDPG1_ENuVd5LfDA",
      [CONTACT_TYPES.WHATS_APP]: getRotatingWhatsAppLink(),
      [CONTACT_TYPES.WE_COM]:
        "https://work.weixin.qq.com/ca/cawcde72cf688c044d?customer_channel=T-onboarding",
    }
    const redirectUrl = window.CrossSellTracker?.getContactRedirectUrl(
      {
        location_uuid: type,
        contact_type: contactId,
        source: "app",
        redirect_url: urlMap[contactId],
      },
      isProduction ? "production" : "test",
    )

    // 自动在新窗口打开
    if (redirectUrl && typeof window !== "undefined") {
      window.open(redirectUrl, "_blank")
    }
    return
  }
  // const appenum = {
  //   [CROSS_SELL_POINT_ENUM.managementUninstallBanner]:
  //     "https://apps.shopify.com/parcelpanel?from=return_managment_banner",
  //   [CROSS_SELL_POINT_ENUM.settingsRule]:
  //     "https://apps.shopify.com/parcelpanel?utm_source=return&utm_medium=integration_card",
  //   [CROSS_SELL_POINT_ENUM.integration]:
  //     "https://apps.shopify.com/parcelpanel?from=addons",
  // }
  const appenum2 = {
    [CROSS_SELL_POINT_ENUM.managementUninstallBanner]: {
      from: "return_managment_banner",
    },
    [CROSS_SELL_POINT_ENUM.settingsRule]: {
      utm_source: "return",
      utm_medium: "integration_card",
    },
    [CROSS_SELL_POINT_ENUM.integration]: {
      from: "addons",
    },
  }

  const installAppUrl = appenum2[type]

  if (installAppUrl) {
    window.CrossSellTracker?.redirectToParcelPanelInstall(type, installAppUrl)
    return
  }
}
